(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jU1Wv", function(module, exports) {

var $ltT5z = parcelRequire("ltT5z");

var $l8I3q = parcelRequire("l8I3q");

var $aMkwP = parcelRequire("aMkwP");
const $9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR = ".swym-wishlist-item";
const $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK = "Product Code";
const $9cf00ee2bbca7138$var$SPECIAL_ORDER_TAG_LABEL = "Special Order";
const $9cf00ee2bbca7138$var$SPECIAL_ORDER_PROPERTY_KEY = "_special_order";
const $9cf00ee2bbca7138$var$getSkuPropertyLabel = ()=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK;
    const fromDataset = container.dataset.labelSku?.trim() ?? "";
    return fromDataset || $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK;
};
const $9cf00ee2bbca7138$var$updateCartItemSkuProperty = async (wishlistItemElement)=>{
    if (!(wishlistItemElement instanceof HTMLElement)) return false;
    const rawVariantId = wishlistItemElement.dataset.variantId?.trim() ?? "";
    const sku = wishlistItemElement.dataset.sku?.trim() ?? "";
    if (!rawVariantId || !sku) return false;
    const numericVariantId = Number(rawVariantId);
    if (!Number.isFinite(numericVariantId)) return false;
    const cart = await (0, $aMkwP.fetchJson)("/cart.js");
    const items = cart?.items;
    if (!items?.length) return false;
    const targetItems = items.filter((item)=>item.variant_id === numericVariantId);
    if (!targetItems.length) return false;
    const specialOrderValue = await $9cf00ee2bbca7138$var$getSpecialOrderPropertyValue(wishlistItemElement);
    const skuPropertyLabel = $9cf00ee2bbca7138$var$getSkuPropertyLabel();
    const updatePayloads = targetItems.reduce((accumulator, targetItem)=>{
        const existingProperties = targetItem.properties;
        const currentSkuRaw = existingProperties && existingProperties[skuPropertyLabel] ? existingProperties[skuPropertyLabel] : null;
        const currentSku = typeof currentSkuRaw === "string" ? currentSkuRaw.trim() : "";
        if (currentSku === sku) return accumulator;
        const properties = {};
        if (existingProperties) for(const key in existingProperties){
            if (!Object.prototype.hasOwnProperty.call(existingProperties, key)) continue;
            if (key === "SKU" || key === skuPropertyLabel) continue;
            const value = existingProperties[key];
            if (typeof value === "string" && value.trim()) properties[key] = value;
        }
        properties[skuPropertyLabel] = sku;
        if (specialOrderValue) properties[$9cf00ee2bbca7138$var$SPECIAL_ORDER_PROPERTY_KEY] = specialOrderValue;
        accumulator.push({
            id: targetItem.key,
            quantity: targetItem.quantity,
            properties: properties
        });
        return accumulator;
    }, []);
    if (!updatePayloads.length) return false;
    try {
        await Promise.all(updatePayloads.map((payload)=>fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(payload)
            })));
        return true;
    } catch  {
        // eslint-disable-next-line no-console
        console.error("Failed to update cart item properties");
    }
    return false;
};
const $9cf00ee2bbca7138$var$getSoldOutLabel = ()=>{
    const body = document.body;
    if (!body) return "";
    const { labelSoldOut: labelSoldOut } = body.dataset;
    return labelSoldOut ?? "";
};
const $9cf00ee2bbca7138$var$disableQfcUnavailableButton = (button)=>{
    if (button.dataset.qfcAvailability === "unavailable") return;
    button.disabled = true;
    button.dataset.qfcAvailability = "unavailable";
    button.setAttribute("aria-disabled", "true");
    const soldOutLabel = $9cf00ee2bbca7138$var$getSoldOutLabel();
    if (soldOutLabel.length > 0) {
        const applyLabel = ()=>{
            if (button.textContent !== soldOutLabel) button.textContent = soldOutLabel;
            button.setAttribute("aria-label", soldOutLabel);
        };
        applyLabel();
        const labelObserver = new MutationObserver(()=>{
            if (button.dataset.qfcAvailability !== "unavailable") {
                labelObserver.disconnect();
                return;
            }
            applyLabel();
        });
        labelObserver.observe(button, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
};
const $9cf00ee2bbca7138$var$getQfcAvailabilityUrl = (button)=>{
    const wishlistItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const detailContainer = button.closest(".swym-wishlist-product-detail-text-container");
    const root = wishlistItem ?? detailContainer;
    if (!root) return "";
    const link = root.querySelector(".swym-wishlist-image-wrapper") ?? root.querySelector(".swym-more-details-btn");
    if (!link) return "";
    const href = link.getAttribute("href");
    if (!href) return "";
    let productUrl;
    try {
        productUrl = href.startsWith("http") ? new URL(href) : new URL(href, window.location.origin);
    } catch (_error) {
        return "";
    }
    const variantId = productUrl.searchParams.get("variant");
    if (!variantId) return "";
    const availabilityUrl = new URL(productUrl.pathname, productUrl.origin || window.location.origin);
    availabilityUrl.searchParams.set("variant", variantId);
    availabilityUrl.searchParams.set("view", "qfc-availability");
    return availabilityUrl.toString();
};
const $9cf00ee2bbca7138$var$initializedButtons = new WeakSet();
const $9cf00ee2bbca7138$var$updateWishlistButtonAvailability = async (button)=>{
    if (button.dataset.qfcAvailability === "unavailable") return;
    const availabilityUrl = $9cf00ee2bbca7138$var$getQfcAvailabilityUrl(button);
    if (!availabilityUrl) return;
    try {
        const response = await fetch(availabilityUrl);
        if (!response.ok) return;
        const availability = await response.json();
        if (!availability.isVariantAvailable) $9cf00ee2bbca7138$var$disableQfcUnavailableButton(button);
    } catch (_error) {
        // eslint-disable-next-line no-console
        console.error("QFC availability check failed");
    }
};
const $9cf00ee2bbca7138$var$getSpecialOrderPropertyValue = async (wishlistItemElement)=>{
    const cached = wishlistItemElement.dataset.specialOrder;
    if (cached === "true") return "true";
    if (cached === "false") return null;
    const handle = $9cf00ee2bbca7138$var$extractHandleFromContext(wishlistItemElement);
    if (!handle) {
        wishlistItemElement.dataset.specialOrder = "false";
        return null;
    }
    const product = await (0, $aMkwP.fetchJson)(`/products/${encodeURIComponent(handle)}.js`);
    const tags = product?.tags;
    if (!tags || !tags.length) {
        wishlistItemElement.dataset.specialOrder = "false";
        return null;
    }
    const expectedTag = $9cf00ee2bbca7138$var$normalizeTag($9cf00ee2bbca7138$var$SPECIAL_ORDER_TAG_LABEL);
    const hasSpecialOrder = tags.some((tag)=>!!tag && $9cf00ee2bbca7138$var$normalizeTag(tag) === expectedTag);
    wishlistItemElement.dataset.specialOrder = hasSpecialOrder ? "true" : "false";
    return hasSpecialOrder ? "true" : null;
};
const $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK = "school";
const $9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR = ".swym-add-to-cart-btn, .swym-wishlist-add-to-cart-btn";
const $9cf00ee2bbca7138$var$WISHLIST_IMAGE_LINK_SELECTOR = "a.swym-wishlist-image-wrapper";
const $9cf00ee2bbca7138$var$WISHLIST_DETAIL_SELECTOR = ".swym-wishlist-product-detail-content";
const $9cf00ee2bbca7138$var$WISHLIST_DETAIL_LINK_SELECTOR = ".swym-more-details-btn.swym-is-anchor";
const $9cf00ee2bbca7138$var$getQuoteConfig = ()=>{
    const config = window.carbatecSchoolQuote;
    if (!config || !config.url || !config.label) return null;
    return {
        url: config.url,
        label: config.label,
        tag: config.tag || $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK
    };
};
const $9cf00ee2bbca7138$var$normalizeTag = (value)=>value.trim().toLowerCase();
const $9cf00ee2bbca7138$var$hasSchoolTag = (tags, schoolTag)=>{
    const expected = $9cf00ee2bbca7138$var$normalizeTag(schoolTag || $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK);
    return tags.some((tag)=>tag && $9cf00ee2bbca7138$var$normalizeTag(tag) === expected);
};
const $9cf00ee2bbca7138$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $9cf00ee2bbca7138$var$extractHandleFromContext = (context)=>{
    const imageLink = context.querySelector($9cf00ee2bbca7138$var$WISHLIST_IMAGE_LINK_SELECTOR);
    const detailsLink = context.querySelector($9cf00ee2bbca7138$var$WISHLIST_DETAIL_LINK_SELECTOR);
    const link = imageLink instanceof HTMLAnchorElement ? imageLink : detailsLink instanceof HTMLAnchorElement ? detailsLink : null;
    if (!link) return null;
    return $9cf00ee2bbca7138$var$extractHandleFromHref(link.href);
};
const $9cf00ee2bbca7138$var$attachSchoolLabelObserver = (button, label)=>{
    if (button.dataset.schoolLabelBound === "true") return;
    button.dataset.schoolLabelBound = "true";
    button.dataset.schoolLabel = label;
    const observer = new MutationObserver(()=>{
        const expectedLabel = button.dataset.schoolLabel;
        if (!expectedLabel) return;
        if (button.textContent === expectedLabel) return;
        button.textContent = expectedLabel;
    });
    observer.observe(button, {
        childList: true,
        characterData: true,
        subtree: true
    });
};
const $9cf00ee2bbca7138$var$disableScmQuoteButton = (button)=>{
    if (button.dataset.scmQuoteOnly === "true") return;
    button.disabled = true;
    button.dataset.scmQuoteOnly = "true";
    button.setAttribute("aria-disabled", "true");
    const soldOutLabel = $9cf00ee2bbca7138$var$getSoldOutLabel();
    if (!soldOutLabel.length) return;
    const applyLabel = ()=>{
        if (button.textContent !== soldOutLabel) button.textContent = soldOutLabel;
        button.setAttribute("aria-label", soldOutLabel);
    };
    applyLabel();
    const labelObserver = new MutationObserver(()=>{
        if (button.dataset.scmQuoteOnly !== "true") {
            labelObserver.disconnect();
            return;
        }
        applyLabel();
    });
    labelObserver.observe(button, {
        childList: true,
        characterData: true,
        subtree: true
    });
};
const $9cf00ee2bbca7138$var$applySchoolQuoteButton = (button, config)=>{
    button.dataset.schoolProduct = "true";
    button.textContent = config.label;
    button.setAttribute("aria-label", config.label);
    $9cf00ee2bbca7138$var$attachSchoolLabelObserver(button, config.label);
};
const $9cf00ee2bbca7138$var$applyQuoteRules = (button, quoteConfig)=>{
    const gridItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const detailItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_DETAIL_SELECTOR);
    const contextElement = gridItem ?? detailItem;
    if (!(contextElement instanceof HTMLElement)) return;
    if (contextElement.dataset.quoteRulesChecked === "true") {
        if (quoteConfig && contextElement.dataset.schoolProduct === "true") $9cf00ee2bbca7138$var$applySchoolQuoteButton(button, quoteConfig);
        if (contextElement.dataset.scmQuoteOnly === "true") $9cf00ee2bbca7138$var$disableScmQuoteButton(button);
        return;
    }
    const handle = $9cf00ee2bbca7138$var$extractHandleFromContext(contextElement);
    if (!handle) {
        contextElement.dataset.quoteRulesChecked = "true";
        contextElement.dataset.schoolProduct = "false";
        contextElement.dataset.scmQuoteOnly = "false";
        return;
    }
    fetch(`/products/${encodeURIComponent(handle)}.js`).then((response)=>response.ok ? response.json() : null).then((data)=>{
        contextElement.dataset.quoteRulesChecked = "true";
        const productTags = Array.isArray(data?.tags) ? data.tags : null;
        const isSchoolProduct = Boolean(quoteConfig) && Array.isArray(productTags) && $9cf00ee2bbca7138$var$hasSchoolTag(productTags, quoteConfig?.tag ?? "");
        contextElement.dataset.schoolProduct = isSchoolProduct ? "true" : "false";
        if (isSchoolProduct && quoteConfig) $9cf00ee2bbca7138$var$applySchoolQuoteButton(button, quoteConfig);
        const isScmQuoteOnly = Boolean(data && (0, $ltT5z.isScmQuoteOnlyTitle)(data.title));
        contextElement.dataset.scmQuoteOnly = isScmQuoteOnly ? "true" : "false";
        if (isScmQuoteOnly) $9cf00ee2bbca7138$var$disableScmQuoteButton(button);
    }).catch(()=>{
        contextElement.dataset.quoteRulesChecked = "true";
        contextElement.dataset.schoolProduct = "false";
        contextElement.dataset.scmQuoteOnly = "false";
    });
};
const $9cf00ee2bbca7138$var$handleButtonClick = (button)=>{
    if (button.dataset.schoolProduct === "true") return;
    if (button.dataset.scmQuoteOnly === "true") return;
    const wishlistItemElement = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const isCartDrawerElement = (element)=>{
        return !!element && "open" in element;
    };
    const syncSkuAndCartDrawer = (delays)=>{
        if (!delays.length) return;
        const [delay, ...nextDelays] = delays;
        window.setTimeout(()=>{
            (async ()=>{
                const didUpdate = await $9cf00ee2bbca7138$var$updateCartItemSkuProperty(wishlistItemElement);
                if (!didUpdate) {
                    syncSkuAndCartDrawer(nextDelays);
                    return;
                }
                const cartDrawer = document.querySelector("cart-drawer");
                if (!isCartDrawerElement(cartDrawer)) return;
                await (0, $l8I3q.updateElements)([
                    ".drawer__inner",
                    ".cart-count-bubble"
                ]);
                cartDrawer.classList.remove("is-empty");
                cartDrawer.open();
            })();
        }, delay);
    };
    syncSkuAndCartDrawer([
        0,
        400,
        1200,
        3000
    ]);
};
const $9cf00ee2bbca7138$var$findAndHandleButtons = ()=>{
    const buttons = document.querySelectorAll($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
    if (!buttons.length) return;
    const quoteConfig = $9cf00ee2bbca7138$var$getQuoteConfig();
    buttons.forEach((button)=>{
        $9cf00ee2bbca7138$var$applyQuoteRules(button, quoteConfig);
    });
};
const $9cf00ee2bbca7138$var$handleWishlistAddToCart = ()=>{
    const applyToButtons = ()=>{
        const buttons = document.querySelectorAll($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
        buttons.forEach((button)=>{
            if ($9cf00ee2bbca7138$var$initializedButtons.has(button)) return;
            $9cf00ee2bbca7138$var$initializedButtons.add(button);
            button.addEventListener("click", ()=>$9cf00ee2bbca7138$var$handleButtonClick(button));
            $9cf00ee2bbca7138$var$updateWishlistButtonAvailability(button);
        });
    };
    const mainObserver = new MutationObserver(()=>{
        applyToButtons();
        $9cf00ee2bbca7138$var$findAndHandleButtons();
    });
    mainObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    applyToButtons();
    $9cf00ee2bbca7138$var$findAndHandleButtons();
};
const $9cf00ee2bbca7138$var$handleWishlistQuoteClick = (event)=>{
    const quoteConfig = $9cf00ee2bbca7138$var$getQuoteConfig();
    if (!quoteConfig) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.schoolProduct !== "true") return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.href = quoteConfig.url;
};
const $9cf00ee2bbca7138$var$initWishlistHandlers = ()=>{
    $9cf00ee2bbca7138$var$handleWishlistAddToCart();
    document.addEventListener("click", $9cf00ee2bbca7138$var$handleWishlistQuoteClick, true);
};
$9cf00ee2bbca7138$var$initWishlistHandlers();

});
parcelRegister("ltT5z", function(module, exports) {

$parcel$export(module.exports, "isScmQuoteOnlyTitle", () => $4543de35537f97fe$export$9e7030f3448037aa);
const $4543de35537f97fe$export$9e7030f3448037aa = (title)=>typeof title === "string" && title.toUpperCase().includes("SCM");

});

parcelRegister("l8I3q", function(module, exports) {

$parcel$export(module.exports, "updateElements", () => $07d5380be57d91f1$export$c5303087167e431c);
const $07d5380be57d91f1$export$c5303087167e431c = async (selectors, sectionId)=>{
    try {
        const response = await fetch(sectionId ? `?sections=${sectionId}` : location.href);
        const html = sectionId ? (await response.json())[sectionId] : await response.text();
        const newdoc = new DOMParser().parseFromString(html, "text/html");
        if (typeof selectors === "string") selectors = [
            selectors
        ];
        for (const selector of selectors){
            const elements = document.querySelectorAll(selector);
            const newElements = newdoc.querySelectorAll(selector);
            if (elements.length !== newElements.length) throw new Error("Elements count mismatch for: " + selector);
            elements.forEach((element, index)=>{
                const newElement = newElements[index];
                if (element && newElement) element.outerHTML = newElement.outerHTML;
            });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error({
            error: error
        });
    }
};

});

parcelRegister("aMkwP", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $349ca6351f33c11f$export$6d71b655afe1638d);
const $349ca6351f33c11f$var$FETCH_TIMEOUT_MS = 8000;
const $349ca6351f33c11f$export$6d71b655afe1638d = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $349ca6351f33c11f$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};

});


parcelRegister("e0FTq", function(module, exports) {
document.addEventListener("click", (event)=>{
    if (event.target instanceof HTMLElement) {
        const isPaginationItem = event.target.closest(".pagination__item");
        if (isPaginationItem) {
            const productGridContainer = document.querySelector(".product-grid-container");
            if (productGridContainer) {
                const header = document.querySelector("header");
                const headerHeight = header ? header.offsetHeight : 0;
                const elementPosition = productGridContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight - 40;
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth"
                });
            } else window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
});

});

parcelRegister("6R7pS", function(module, exports) {
function $5e9671ce07f3b44c$var$initRepairNetwork(componentNode) {
    if (!(componentNode instanceof HTMLElement)) return;
    if (componentNode.dataset.repairNetworkBound === "true") return;
    componentNode.dataset.repairNetworkBound = "true";
    const repairSelect = componentNode.querySelector("[data-repair-network-select]");
    if (!(repairSelect instanceof HTMLSelectElement)) return;
    const cardNodes = Array.from(componentNode.querySelectorAll("[data-repair-network-item]"));
    const repairCards = cardNodes.filter((node)=>node instanceof HTMLElement).map((element)=>({
            element: element,
            key: element.dataset.key ?? ""
        }));
    const showSelectedByKey = (selectedKey)=>{
        repairCards.forEach(({ element: element, key: key })=>{
            if (key === selectedKey) element.removeAttribute("hidden");
            else element.setAttribute("hidden", "hidden");
        });
    };
    repairSelect.addEventListener("change", ()=>showSelectedByKey(repairSelect.value));
    showSelectedByKey(repairSelect.value);
}
function $5e9671ce07f3b44c$var$mountRepairNetworksIn(rootNode) {
    Array.from(rootNode.querySelectorAll("[data-repair-network]")).forEach($5e9671ce07f3b44c$var$initRepairNetwork);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5e9671ce07f3b44c$var$mountRepairNetworksIn(document));
else $5e9671ce07f3b44c$var$mountRepairNetworksIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetNode = event.target;
    if (targetNode instanceof HTMLElement) $5e9671ce07f3b44c$var$mountRepairNetworksIn(targetNode);
});

});

parcelRegister("695Bn", function(module, exports) {
const $06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID = "searchspring-content";
const $06e543d4b42faeb6$var$SPECIAL_ORDER_TAG_NORMALIZED = "special order";
const $06e543d4b42faeb6$var$PRODUCT_LINK_SELECTOR = "a[href*='/products/']";
const $06e543d4b42faeb6$var$specialOrderCache = {};
const $06e543d4b42faeb6$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $06e543d4b42faeb6$var$findProductHandleForForm = (form)=>{
    let current = form;
    while(current && current.id !== $06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID){
        const link = current.querySelector($06e543d4b42faeb6$var$PRODUCT_LINK_SELECTOR);
        if (link) return $06e543d4b42faeb6$var$extractHandleFromHref(link.href);
        current = current.parentElement;
    }
    return null;
};
const $06e543d4b42faeb6$var$fetchIsSpecialOrder = async (handle)=>{
    const cached = $06e543d4b42faeb6$var$specialOrderCache[handle];
    if (cached !== undefined) return cached;
    try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) {
            $06e543d4b42faeb6$var$specialOrderCache[handle] = false;
            return false;
        }
        const data = await response.json();
        const tags = Array.isArray(data.tags) ? data.tags : [];
        const isSpecialOrder = tags.some((tag)=>tag && tag.trim().toLowerCase() === $06e543d4b42faeb6$var$SPECIAL_ORDER_TAG_NORMALIZED);
        $06e543d4b42faeb6$var$specialOrderCache[handle] = isSpecialOrder;
        return isSpecialOrder;
    } catch  {
        $06e543d4b42faeb6$var$specialOrderCache[handle] = false;
        return false;
    }
};
const $06e543d4b42faeb6$var$ensureSpecialOrderInput = (form)=>{
    const existingInput = form.querySelector('input[name="properties[_special_order]"]');
    if (existingInput) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_special_order]";
    input.value = "true";
    form.append(input);
};
const $06e543d4b42faeb6$var$prepareFormIfSpecialOrderOnSubmit = async (form)=>{
    const handle = $06e543d4b42faeb6$var$findProductHandleForForm(form);
    if (!handle) return;
    const isSpecialOrder = await $06e543d4b42faeb6$var$fetchIsSpecialOrder(handle);
    if (!isSpecialOrder) return;
    $06e543d4b42faeb6$var$ensureSpecialOrderInput(form);
};
const $06e543d4b42faeb6$var$initSearchspringSpecialOrder = ()=>{
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const submitButton = target.closest('button[type="submit"]') ?? target.closest('input[type="submit"]');
        if (!submitButton) return;
        const form = submitButton.form ?? submitButton.closest("form");
        if (!form) return;
        const root = document.getElementById($06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID);
        if (!root || !root.contains(form)) return;
        if (!form.querySelector('input[name="id"]')) return;
        event.preventDefault();
        event.stopPropagation();
        const submitForm = ()=>{
            if (typeof form.requestSubmit === "function") form.requestSubmit(submitButton);
            else form.submit();
        };
        (async ()=>{
            try {
                await $06e543d4b42faeb6$var$prepareFormIfSpecialOrderOnSubmit(form);
            } finally{
                submitForm();
            }
        })();
    }, true);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $06e543d4b42faeb6$var$initSearchspringSpecialOrder);
else $06e543d4b42faeb6$var$initSearchspringSpecialOrder();

});

parcelRegister("9ei6z", function(module, exports) {
const $19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID = "searchspring-content";
const $19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR = "a[href*='/products/']";
const $19e307b0da6eeb4e$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $19e307b0da6eeb4e$var$findProductHandleForForm = (form)=>{
    const directLink = form.querySelector($19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR);
    if (directLink) return $19e307b0da6eeb4e$var$extractHandleFromHref(directLink.href);
    let current = form.parentElement;
    while(current && current.id !== $19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID){
        const link = current.querySelector($19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR);
        if (link) return $19e307b0da6eeb4e$var$extractHandleFromHref(link.href);
        current = current.parentElement;
    }
    return null;
};
const $19e307b0da6eeb4e$var$fetchProduct = async (handle)=>{
    try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return null;
        const data = await response.json();
        return data;
    } catch  {
        return null;
    }
};
const $19e307b0da6eeb4e$var$findVariantSku = (product, variantIdRaw)=>{
    const variants = product?.variants;
    if (!variants || !variants.length) return null;
    const numericVariantId = Number(variantIdRaw);
    if (!Number.isFinite(numericVariantId)) return null;
    const rawSku = variants.find((variant)=>variant.id === numericVariantId)?.sku;
    const trimmed = rawSku?.trim() ?? "";
    return trimmed || null;
};
const $19e307b0da6eeb4e$var$getSkuPropertyLabel = ()=>{
    const root = document.getElementById($19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID);
    if (!(root instanceof HTMLElement)) return "SKU";
    const fromDataset = root.dataset.labelSkuPair?.trim() ?? root.dataset.labelSku?.trim() ?? "";
    return fromDataset || "SKU";
};
const $19e307b0da6eeb4e$var$ensureSkuPropertyInput = (form, label, sku)=>{
    const trimmedSku = sku.trim();
    if (!trimmedSku) return;
    const name = `properties[${label}]`;
    const existingInput = form.querySelector(`input[name="${name}"]`);
    if (existingInput) {
        existingInput.value = trimmedSku;
        existingInput.disabled = false;
        return;
    }
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = trimmedSku;
    form.append(input);
};
const $19e307b0da6eeb4e$var$enhanceFormBeforeSubmit = async (form)=>{
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const variantIdRaw = idInput.value.trim();
    if (!variantIdRaw) return;
    const handle = $19e307b0da6eeb4e$var$findProductHandleForForm(form);
    if (!handle) return;
    const product = await $19e307b0da6eeb4e$var$fetchProduct(handle);
    const sku = $19e307b0da6eeb4e$var$findVariantSku(product, variantIdRaw);
    if (!sku) return;
    const label = $19e307b0da6eeb4e$var$getSkuPropertyLabel();
    $19e307b0da6eeb4e$var$ensureSkuPropertyInput(form, label, sku);
    if (label !== "SKU") {
        const legacyInput = form.querySelector('input[name="properties[SKU]"]');
        if (legacyInput) legacyInput.remove();
    }
};
const $19e307b0da6eeb4e$var$initSearchspringAddToCartSku = ()=>{
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const submitButton = target.closest('button[type="submit"]') ?? target.closest('input[type="submit"]');
        if (!submitButton) return;
        const form = submitButton.form ?? submitButton.closest("form");
        if (!form) return;
        const root = document.getElementById($19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID);
        if (!root || !root.contains(form)) return;
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput) return;
        event.preventDefault();
        event.stopPropagation();
        const submitForm = ()=>{
            if (typeof form.requestSubmit === "function") form.requestSubmit(submitButton);
            else form.submit();
        };
        (async ()=>{
            try {
                await $19e307b0da6eeb4e$var$enhanceFormBeforeSubmit(form);
            } finally{
                submitForm();
            }
        })();
    }, true);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $19e307b0da6eeb4e$var$initSearchspringAddToCartSku);
else $19e307b0da6eeb4e$var$initSearchspringAddToCartSku();

});

parcelRegister("aKoSb", function(module, exports) {
const $9fa85180a8f52b36$var$ROOT_SELECTOR = "[data-ss-recommendations-root]";
const $9fa85180a8f52b36$var$CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const $9fa85180a8f52b36$var$initSwym = (selector)=>{
    const run = ()=>window._swat?.initializeActionButtons(selector);
    if (window._swat?.initializeActionButtons) run();
    else (window.SwymCallbacks = window.SwymCallbacks || []).push(run);
};
document.querySelectorAll($9fa85180a8f52b36$var$ROOT_SELECTOR).forEach((root)=>{
    const id = root.dataset.ssSectionId;
    if (!id) return;
    const selector = `[data-ss-section-id="${id}"]`;
    if (root.querySelector($9fa85180a8f52b36$var$CARD_SELECTOR)) return $9fa85180a8f52b36$var$initSwym(selector);
    const observer = new MutationObserver(()=>{
        if (!root.querySelector($9fa85180a8f52b36$var$CARD_SELECTOR)) return;
        observer.disconnect();
        $9fa85180a8f52b36$var$initSwym(selector);
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
});

});

parcelRegister("dcGpq", function(module, exports) {
const $a4d55e2dc12c4990$var$COUNT_CONTAINER_SELECTORS = [
    ".product-count__text",
    ".mobile-facets__header-inner"
];
const $a4d55e2dc12c4990$var$COUNT_SPAN_SELECTOR = $a4d55e2dc12c4990$var$COUNT_CONTAINER_SELECTORS.map((selector)=>`${selector} .product-count__full`).join(", ");
let $a4d55e2dc12c4990$var$lastCount = null;
let $a4d55e2dc12c4990$var$mobileBound = false;
let $a4d55e2dc12c4990$var$reapplyObserver = null;
let $a4d55e2dc12c4990$var$waitForRootObserver = null;
function $a4d55e2dc12c4990$var$getSiteId() {
    const raw = document.body?.dataset?.ssSiteId;
    const trimmed = raw?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : null;
}
function $a4d55e2dc12c4990$var$getCollectionHandle() {
    const raw = document.body?.dataset?.ssCollectionHandle;
    const trimmed = raw?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : null;
}
function $a4d55e2dc12c4990$var$buildApiUrl() {
    const siteId = $a4d55e2dc12c4990$var$getSiteId();
    if (!siteId) throw new Error("SearchSpring siteId is missing from document.body.dataset.ssSiteId");
    const apiUrl = new URL(`https://${siteId}.a.searchspring.io/api/search/search.json`);
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const isSearchPage = pathSegments[0] === "search";
    apiUrl.searchParams.set("siteId", siteId);
    apiUrl.searchParams.set("resultsFormat", "native");
    apiUrl.searchParams.set("resultsPerPage", isSearchPage ? "48" : "1");
    apiUrl.searchParams.set("page", "1");
    const configuredCollectionHandle = $a4d55e2dc12c4990$var$getCollectionHandle();
    const collectionsIndex = pathSegments.indexOf("collections");
    const urlCollectionHandle = collectionsIndex >= 0 ? pathSegments[collectionsIndex + 1] ?? "" : "";
    let collectionHandleToUse = urlCollectionHandle || configuredCollectionHandle || "";
    if (urlCollectionHandle === "vendors" && configuredCollectionHandle) collectionHandleToUse = configuredCollectionHandle;
    if (!isSearchPage && collectionHandleToUse) apiUrl.searchParams.set("bgfilter.collection_handle", collectionHandleToUse);
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get("q");
    if (searchQuery) apiUrl.searchParams.set("q", searchQuery);
    location.hash.replace(/^#/, "").split("/").forEach((segment)=>{
        if (!segment.startsWith("filter:")) return;
        const keyValue = segment.slice(7);
        const colonIndex = keyValue.indexOf(":");
        if (colonIndex <= 0 || colonIndex >= keyValue.length - 1) return;
        const key = keyValue.slice(0, colonIndex);
        const rawValue = keyValue.slice(colonIndex + 1);
        if (key === "ss_price" && rawValue.includes(":")) {
            const [low, high] = rawValue.split(":");
            if (low !== undefined && low !== "") apiUrl.searchParams.set("filter.ss_price.low", low);
            if (high !== undefined && high !== "") apiUrl.searchParams.set("filter.ss_price.high", high);
        } else {
            let value = rawValue;
            if (value.includes("$25")) try {
                value = decodeURIComponent(value.replace(/\$25/g, "%"));
            } catch (error) {
                console.warn("SearchSpring product count: failed to decode filter value", value, error);
            }
            // allow multiple values for the same filter key (OR logic)
            apiUrl.searchParams.append(`filter.${key}`, value);
        }
    });
    searchParams.forEach((value, key)=>{
        if (key.startsWith("filter.")) apiUrl.searchParams.append(key, value);
    });
    return apiUrl.toString();
}
async function $a4d55e2dc12c4990$var$getCount() {
    const response = await fetch($a4d55e2dc12c4990$var$buildApiUrl());
    if (!response.ok) throw new Error(`SearchSpring product count failed: ${response.status} ${response.statusText}`);
    const data = await response.json();
    const total = data?.pagination?.totalResults;
    if (typeof total !== "number" || !Number.isFinite(total)) throw new Error("SearchSpring returned invalid totalResults");
    return Math.floor(total);
}
function $a4d55e2dc12c4990$var$applyCount(count) {
    const countText = `${count} products`;
    $a4d55e2dc12c4990$var$COUNT_CONTAINER_SELECTORS.forEach((containerSelector)=>document.querySelectorAll(containerSelector).forEach((container)=>{
            if (!container.querySelector(".product-count__full")) {
                const countSpan = document.createElement("span");
                countSpan.className = "product-count__full";
                container.appendChild(countSpan);
            }
        }));
    document.querySelectorAll($a4d55e2dc12c4990$var$COUNT_SPAN_SELECTOR).forEach((span)=>span.textContent = countText);
}
function $a4d55e2dc12c4990$var$bindMobile() {
    if ($a4d55e2dc12c4990$var$mobileBound) return;
    const button = document.querySelector(".ss__slideout__button");
    if (!button) return;
    $a4d55e2dc12c4990$var$mobileBound = true;
    button.addEventListener("click", ()=>{
        if ($a4d55e2dc12c4990$var$lastCount !== null) $a4d55e2dc12c4990$var$applyCount($a4d55e2dc12c4990$var$lastCount);
    });
}
let $a4d55e2dc12c4990$var$reapplyScheduled = false;
function $a4d55e2dc12c4990$var$scheduleReapply() {
    if ($a4d55e2dc12c4990$var$reapplyScheduled) return;
    $a4d55e2dc12c4990$var$reapplyScheduled = true;
    requestAnimationFrame(()=>{
        $a4d55e2dc12c4990$var$reapplyScheduled = false;
        if ($a4d55e2dc12c4990$var$lastCount !== null) $a4d55e2dc12c4990$var$applyCount($a4d55e2dc12c4990$var$lastCount);
        $a4d55e2dc12c4990$var$bindMobile();
    });
}
function $a4d55e2dc12c4990$var$ensureReapplyOnDomChange() {
    if ($a4d55e2dc12c4990$var$reapplyObserver) return;
    const searchspringRoot = document.getElementById("searchspring-content");
    if (searchspringRoot) {
        $a4d55e2dc12c4990$var$reapplyObserver = new MutationObserver(()=>$a4d55e2dc12c4990$var$scheduleReapply());
        $a4d55e2dc12c4990$var$reapplyObserver.observe(searchspringRoot, {
            childList: true,
            subtree: true
        });
        return;
    }
    if ($a4d55e2dc12c4990$var$waitForRootObserver) return;
    $a4d55e2dc12c4990$var$waitForRootObserver = new MutationObserver(()=>{
        if (!document.getElementById("searchspring-content")) return;
        $a4d55e2dc12c4990$var$waitForRootObserver?.disconnect();
        $a4d55e2dc12c4990$var$waitForRootObserver = null;
        $a4d55e2dc12c4990$var$ensureReapplyOnDomChange();
    });
    $a4d55e2dc12c4990$var$waitForRootObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function $a4d55e2dc12c4990$var$run() {
    $a4d55e2dc12c4990$var$getCount().then((count)=>{
        $a4d55e2dc12c4990$var$lastCount = count;
        $a4d55e2dc12c4990$var$applyCount(count);
        $a4d55e2dc12c4990$var$ensureReapplyOnDomChange();
    }).catch((error)=>{
        console.warn("SearchSpring product count failed", error);
    });
}
function $a4d55e2dc12c4990$var$wrapHistoryMethod(methodName) {
    const originalMethod = history[methodName];
    return function(...args) {
        const result = originalMethod.apply(this, args);
        $a4d55e2dc12c4990$var$run();
        return result;
    };
}
function $a4d55e2dc12c4990$var$init() {
    if (!$a4d55e2dc12c4990$var$getSiteId()) return;
    if (document.body?.dataset?.ssProductCountSource === "theme") return;
    history.pushState = $a4d55e2dc12c4990$var$wrapHistoryMethod("pushState");
    history.replaceState = $a4d55e2dc12c4990$var$wrapHistoryMethod("replaceState");
    addEventListener("popstate", $a4d55e2dc12c4990$var$run);
    addEventListener("hashchange", $a4d55e2dc12c4990$var$run);
    $a4d55e2dc12c4990$var$bindMobile();
    $a4d55e2dc12c4990$var$run();
}
addEventListener("DOMContentLoaded", $a4d55e2dc12c4990$var$init);

});

parcelRequire("jU1Wv");
parcelRequire("e0FTq");
parcelRequire("6R7pS");
const $cd2df92b128184fc$var$TOGGLE_SELECTOR = ".category-slider__description-toggle";
const $cd2df92b128184fc$var$COLLAPSIBLE_CLASS = "is-collapsible";
const $cd2df92b128184fc$var$OPEN_CLASS = "is-open";
const $cd2df92b128184fc$var$btn = document.querySelector($cd2df92b128184fc$var$TOGGLE_SELECTOR);
if ($cd2df92b128184fc$var$btn instanceof HTMLButtonElement) {
    $cd2df92b128184fc$var$btn.classList.add("is-ready");
    const id = $cd2df92b128184fc$var$btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (wrap) {
        wrap.classList.add($cd2df92b128184fc$var$COLLAPSIBLE_CLASS);
        const expanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
        wrap.setAttribute("aria-hidden", String(!expanded));
        if (expanded) {
            wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;
        }
        $cd2df92b128184fc$var$btn.addEventListener("click", ()=>{
            const isExpanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
            if (!isExpanded) {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "true");
                wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
                wrap.setAttribute("aria-hidden", "false");
                requestAnimationFrame(()=>{
                    wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                });
            } else {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "false");
                wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                requestAnimationFrame(()=>{
                    wrap.classList.remove($cd2df92b128184fc$var$OPEN_CLASS);
                    wrap.setAttribute("aria-hidden", "true");
                    wrap.style.maxHeight = "";
                });
            }
            const labelMore = $cd2df92b128184fc$var$btn.dataset.labelMore;
            const labelLess = $cd2df92b128184fc$var$btn.dataset.labelLess;
            const span = $cd2df92b128184fc$var$btn.querySelector("span");
            if (span && labelMore && labelLess) span.textContent = isExpanded ? labelMore : labelLess;
        });
    }
}


const $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG = "percentage-off-sale";
const $7d1b13016aa3d0bd$var$SPECIAL_ORDER_TAG = "special-order";
const $7d1b13016aa3d0bd$var$UNKNOWN_LOCATION_RANK = 10;
const $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY = 100;
const $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId = new Map();
async function $7d1b13016aa3d0bd$export$8545333153626f43(siteId, fetchJson) {
    const normalizedSiteId = siteId;
    if (!normalizedSiteId) return null;
    const cached = $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId.get(normalizedSiteId);
    if (cached !== undefined) return cached;
    const url = `https://${normalizedSiteId}.a.searchspring.io/api/meta/meta?siteId=${normalizedSiteId}`;
    let data;
    try {
        data = await fetchJson(url);
    } catch  {
        return null;
    }
    const rawTagsConfig = data?.badges?.tags;
    const tagsConfig = rawTagsConfig && typeof rawTagsConfig === "object" && !Array.isArray(rawTagsConfig) ? rawTagsConfig : null;
    $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId.set(normalizedSiteId, tagsConfig);
    return tagsConfig;
}
function $7d1b13016aa3d0bd$var$getLocationRank(location) {
    if (location === "callout") return 0;
    if (location === "left") return 1;
    if (location === "right") return 2;
    return $7d1b13016aa3d0bd$var$UNKNOWN_LOCATION_RANK;
}
function $7d1b13016aa3d0bd$export$1a6553668c5e7a2c(containerElement, badges, tagsConfig) {
    const normalizedBadges = badges.map((badge, index)=>({
            index: index,
            tag: typeof badge.tag === "string" ? badge.tag.trim() : "",
            value: typeof badge.value === "string" ? badge.value.trim() : ""
        }));
    const hasPercentageOff = normalizedBadges.some((badge)=>badge.tag === $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG);
    const filteredBadges = normalizedBadges.filter((badge)=>{
        if (!badge.tag && !badge.value) return false;
        if (badge.tag === "sale" && hasPercentageOff) return false;
        if (badge.tag === $7d1b13016aa3d0bd$var$SPECIAL_ORDER_TAG) return false;
        if (badge.value.toLowerCase().includes("special order")) return false;
        if (!tagsConfig || !badge.tag) return true;
        return tagsConfig[badge.tag]?.enabled !== false;
    });
    if (!filteredBadges.length) return;
    if (tagsConfig) filteredBadges.sort((leftBadge, rightBadge)=>{
        const leftConfig = tagsConfig[leftBadge.tag];
        const rightConfig = tagsConfig[rightBadge.tag];
        const leftLocationRank = $7d1b13016aa3d0bd$var$getLocationRank(leftConfig?.location?.split("/")[0]);
        const rightLocationRank = $7d1b13016aa3d0bd$var$getLocationRank(rightConfig?.location?.split("/")[0]);
        if (leftLocationRank !== rightLocationRank) return leftLocationRank - rightLocationRank;
        const leftPriority = typeof leftConfig?.priority === "number" ? leftConfig.priority : $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY;
        const rightPriority = typeof rightConfig?.priority === "number" ? rightConfig.priority : $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY;
        if (leftPriority !== rightPriority) return leftPriority - rightPriority;
        return leftBadge.index - rightBadge.index;
    });
    const fragment = document.createDocumentFragment();
    for (const badge of filteredBadges){
        const { tag: tag, value: value } = badge;
        const badgeWrapper = document.createElement("div");
        const wrapperClasses = [
            "card__badge",
            "top"
        ];
        if (tagsConfig && tag) {
            const location = tagsConfig[tag]?.location;
            const locationKey = location?.split("/")[0] ?? "";
            if (locationKey === "right") wrapperClasses.push("right");
        }
        badgeWrapper.className = wrapperClasses.join(" ");
        const badgeLabel = document.createElement("span");
        badgeLabel.className = tagsConfig ? "ss-pdp-badge" : "ss-pdp-badge-default";
        const parameters = tagsConfig?.[tag]?.parameters;
        if (parameters?.colorText) badgeLabel.style.color = parameters.colorText;
        if (parameters?.color) badgeLabel.style.backgroundColor = parameters.color;
        const imageUrl = parameters?.url;
        if (imageUrl) {
            const image = document.createElement("img");
            image.className = "ss-pdp-badge-img";
            image.src = imageUrl;
            image.alt = value || tag;
            badgeLabel.textContent = "";
            badgeLabel.append(image);
        } else badgeLabel.textContent = tag === $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG && value ? `${value}` : value || tag;
        badgeWrapper.append(badgeLabel);
        fragment.append(badgeWrapper);
    }
    containerElement.classList.add("card__badges");
    if (!tagsConfig) containerElement.classList.add("badges", "badges--top-left");
    containerElement.append(fragment);
}


const $5d96ad27182ef356$var$SEARCHSPRING_API_URL = "https://api.searchspring.net/api/search/search.json";
const $5d96ad27182ef356$var$SEARCHSPRING_FETCH_TIMEOUT_MS = 8000;
const $5d96ad27182ef356$var$CARD_BADGES_ENTITY = "ss-card-badges";
const $5d96ad27182ef356$var$isSoldOutBadge = (badge)=>{
    const normalizedTag = (badge.tag ?? "").trim().toLowerCase();
    const normalizedValue = (badge.value ?? "").trim().toLowerCase();
    return normalizedTag === "sold-out" || normalizedTag === "soldout" || normalizedTag.includes("sold out") || normalizedValue.includes("sold out");
};
const $5d96ad27182ef356$var$isAvailableBadge = (badge)=>!$5d96ad27182ef356$var$isSoldOutBadge(badge);
const $5d96ad27182ef356$var$fetchSearchspringJson = (url)=>{
    const controller = new AbortController();
    const timeoutId = window.setTimeout(()=>controller.abort(), $5d96ad27182ef356$var$SEARCHSPRING_FETCH_TIMEOUT_MS);
    return fetch(url, {
        credentials: "omit",
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>window.clearTimeout(timeoutId));
};
async function $5d96ad27182ef356$var$fetchBadgesForHandles(siteId, handles) {
    if (!handles.length) return new Map();
    const queryParams = new URLSearchParams();
    queryParams.set("siteId", siteId);
    queryParams.set("resultsFormat", "native");
    queryParams.set("resultsPerPage", String(handles.length));
    const handleFilterParam = "filter.handle";
    handles.forEach((handle)=>queryParams.append(handleFilterParam, handle));
    const requestUrl = `${$5d96ad27182ef356$var$SEARCHSPRING_API_URL}?${queryParams.toString()}`;
    const responseData = await $5d96ad27182ef356$var$fetchSearchspringJson(requestUrl);
    const searchResults = responseData?.results ?? [];
    const badgesByHandle = new Map();
    searchResults.forEach((result)=>{
        const handle = typeof result.handle === "string" ? result.handle.trim() : "";
        if (!handle || badgesByHandle.has(handle)) return;
        badgesByHandle.set(handle, Array.isArray(result.badges) ? result.badges : []);
    });
    return badgesByHandle;
}
function $5d96ad27182ef356$var$getOrCreateBadgesRoot(parent, badgesSelector, badgesEntity) {
    const existingBadgesRoot = parent.querySelector(badgesSelector);
    if (existingBadgesRoot instanceof HTMLElement) return existingBadgesRoot;
    const badgesRootElement = document.createElement("div");
    badgesRootElement.dataset.entity = badgesEntity;
    badgesRootElement.className = "ss__pdp-badges";
    badgesRootElement.setAttribute("aria-live", "polite");
    parent.insertBefore(badgesRootElement, parent.firstChild);
    return badgesRootElement;
}
async function $5d96ad27182ef356$export$18625d2560c7ad35({ siteId: siteId, cards: cards, getHandleFromCard: getHandleFromCard, getBadgesHost: getBadgesHost, shouldSkipCard: shouldSkipCard, badgesEntity: badgesEntity = $5d96ad27182ef356$var$CARD_BADGES_ENTITY }) {
    const normalizedSiteId = siteId.trim();
    if (!normalizedSiteId) return;
    if (!cards.length) return;
    const handles = [];
    const seen = new Set();
    cards.forEach((card)=>{
        if (shouldSkipCard?.(card)) return;
        const handle = getHandleFromCard(card).trim();
        if (!handle || seen.has(handle)) return;
        seen.add(handle);
        handles.push(handle);
    });
    if (!handles.length) return;
    const badgesSelector = `[data-entity="${badgesEntity}"]`;
    const [badgesByHandle, tagsConfig] = await Promise.all([
        $5d96ad27182ef356$var$fetchBadgesForHandles(normalizedSiteId, handles),
        (0, $7d1b13016aa3d0bd$export$8545333153626f43)(normalizedSiteId, $5d96ad27182ef356$var$fetchSearchspringJson)
    ]);
    const isCardBadges = badgesEntity === $5d96ad27182ef356$var$CARD_BADGES_ENTITY;
    cards.forEach((card)=>{
        if (shouldSkipCard?.(card)) return;
        const handle = getHandleFromCard(card).trim();
        if (!handle) return;
        const host = getBadgesHost?.(card) ?? card.querySelector(".card__inner, .card") ?? card;
        const fetchedBadges = badgesByHandle.get(handle) ?? [];
        const productBadges = isCardBadges ? fetchedBadges.filter($5d96ad27182ef356$var$isAvailableBadge) : fetchedBadges;
        if (!productBadges.length) return host.querySelector(badgesSelector)?.remove();
        const badgesRoot = $5d96ad27182ef356$var$getOrCreateBadgesRoot(host, badgesSelector, badgesEntity);
        badgesRoot.replaceChildren();
        (0, $7d1b13016aa3d0bd$export$1a6553668c5e7a2c)(badgesRoot, productBadges, tagsConfig);
    });
}


const $c1e80430a91987d7$var$PRODUCT_SLIDER_TABS_SELECTOR = ".js-tabs";
const $c1e80430a91987d7$var$PRODUCT_SLIDE_SELECTOR = "swiper-slide[data-product-handle]";
function $c1e80430a91987d7$var$getSiteIdFromContainer(tabsContainer) {
    return tabsContainer.dataset.siteId?.trim() ?? "";
}
async function $c1e80430a91987d7$var$runForContainer(tabsContainer) {
    const siteId = $c1e80430a91987d7$var$getSiteIdFromContainer(tabsContainer);
    if (!siteId) return;
    const productSlideElements = tabsContainer.querySelectorAll($c1e80430a91987d7$var$PRODUCT_SLIDE_SELECTOR);
    if (!productSlideElements.length) return;
    await (0, $5d96ad27182ef356$export$18625d2560c7ad35)({
        siteId: siteId,
        cards: productSlideElements,
        getHandleFromCard: (card)=>card.dataset.productHandle?.trim() ?? ""
    });
}
function $c1e80430a91987d7$var$mountIn(root) {
    root.querySelectorAll($c1e80430a91987d7$var$PRODUCT_SLIDER_TABS_SELECTOR).forEach((container)=>{
        if (!(container instanceof HTMLElement)) return;
        $c1e80430a91987d7$var$runForContainer(container);
    });
}
$c1e80430a91987d7$var$mountIn(document);



const $f6ca92b84c36e611$var$ROOT_SELECTOR = ".pair-it-with";
const $f6ca92b84c36e611$var$CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const $f6ca92b84c36e611$var$LINK_SELECTOR = 'a[href*="/products/"]';
const $f6ca92b84c36e611$var$OVERLAY_SELECTOR = ".ss__overlay-badge";
const $f6ca92b84c36e611$var$getSiteId = ()=>document.body.dataset.ssSiteId?.trim() ?? "";
const $f6ca92b84c36e611$var$getHandleFromCard = (card)=>{
    const href = card.querySelector($f6ca92b84c36e611$var$LINK_SELECTOR)?.getAttribute("href") ?? "";
    if (!href) return "";
    const match = href.match(/\/products\/([^/?#]+)/);
    return match?.[1]?.trim() ?? "";
};
const $f6ca92b84c36e611$var$mountBadgesInRoot = async (root)=>{
    const siteId = $f6ca92b84c36e611$var$getSiteId();
    if (!siteId) return;
    const cards = root.querySelectorAll($f6ca92b84c36e611$var$CARD_SELECTOR);
    if (!cards.length) return;
    await (0, $5d96ad27182ef356$export$18625d2560c7ad35)({
        siteId: siteId,
        cards: cards,
        getHandleFromCard: $f6ca92b84c36e611$var$getHandleFromCard,
        shouldSkipCard: (card)=>Boolean(card.querySelector($f6ca92b84c36e611$var$OVERLAY_SELECTOR))
    });
};
const $f6ca92b84c36e611$var$mountIn = (container)=>{
    container.querySelectorAll($f6ca92b84c36e611$var$ROOT_SELECTOR).forEach((root)=>{
        $f6ca92b84c36e611$var$mountBadgesInRoot(root);
    });
};
$f6ca92b84c36e611$var$mountIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    if (!(event.target instanceof HTMLElement)) return;
    $f6ca92b84c36e611$var$mountIn(event.target);
});


const $9eeffc371cf003ec$var$ROOT_SELECTOR = ".collection-seo-description";
const $9eeffc371cf003ec$var$TOGGLE_SELECTOR = ".collection-seo-description__toggle";
const $9eeffc371cf003ec$var$TEXT_SELECTOR = ".collection-seo-description__text";
const $9eeffc371cf003ec$var$OPEN_CLASS = "is-open";
const $9eeffc371cf003ec$var$READY_CLASS = "is-ready";
const $9eeffc371cf003ec$var$initCollectionSeoDescription = (root)=>{
    const section = root.querySelector($9eeffc371cf003ec$var$ROOT_SELECTOR);
    if (!section) return;
    const btn = section.querySelector($9eeffc371cf003ec$var$TOGGLE_SELECTOR);
    if (!btn) return;
    const id = btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (!wrap) return;
    const text = wrap.querySelector($9eeffc371cf003ec$var$TEXT_SELECTOR);
    if (!text) return;
    wrap.classList.remove($9eeffc371cf003ec$var$OPEN_CLASS);
    btn.setAttribute("aria-expanded", "false");
    wrap.setAttribute("aria-hidden", "false");
    const isClamped = ()=>text.scrollHeight > text.clientHeight + 1;
    if (!isClamped()) return;
    btn.classList.add($9eeffc371cf003ec$var$READY_CLASS);
    btn.addEventListener("click", ()=>{
        const nextExpanded = btn.getAttribute("aria-expanded") !== "true";
        btn.setAttribute("aria-expanded", String(nextExpanded));
        wrap.classList.toggle($9eeffc371cf003ec$var$OPEN_CLASS, nextExpanded);
        wrap.setAttribute("aria-hidden", "false");
    });
};
$9eeffc371cf003ec$var$initCollectionSeoDescription(document);
document.addEventListener("shopify:section:load", (e)=>{
    const target = e.target;
    if (target instanceof HTMLElement) $9eeffc371cf003ec$var$initCollectionSeoDescription(target);
});


const $b40ffbb47bd41a36$export$7249499643f8b365 = "carbatec_compare";
const $b40ffbb47bd41a36$export$c4cbb7f74da17435 = 3;
const $b40ffbb47bd41a36$export$5cfeaa4af6841c8f = (value)=>{
    const el = document.createElement("div");
    el.innerHTML = value;
    return el.textContent ?? value;
};
const $b40ffbb47bd41a36$export$5e5806013e2fd7ad = ()=>{
    try {
        const raw = localStorage.getItem($b40ffbb47bd41a36$export$7249499643f8b365);
        const list = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(list)) return [];
        const items = [];
        for (const entry of list){
            if (typeof entry !== "object" || entry === null) continue;
            const urlValue = Reflect.get(entry, "url");
            const url = String(urlValue ?? "").trim();
            if (!url) continue;
            const imageSrcValue = Reflect.get(entry, "imageSrc");
            const imageSrc = typeof imageSrcValue === "string" ? imageSrcValue : undefined;
            items.push({
                url: url,
                imageSrc: imageSrc
            });
        }
        return items;
    } catch  {
        return [];
    }
};
const $b40ffbb47bd41a36$export$de3ad5aa5028f2d0 = ()=>$b40ffbb47bd41a36$export$5e5806013e2fd7ad().map((item)=>/\/products\/([^/?]+)/.exec(item.url)?.[1] || "").filter(Boolean).slice(0, $b40ffbb47bd41a36$export$c4cbb7f74da17435);


const $b913860f6c9836f6$var$writeStoredItems = (items)=>{
    try {
        localStorage.setItem((0, $b40ffbb47bd41a36$export$7249499643f8b365), JSON.stringify(items));
        window.dispatchEvent(new CustomEvent("carbatec:compare-changed"));
    } catch (error) {
        console.error("[compare] Failed to write compare list to localStorage", error);
    }
};
const $b913860f6c9836f6$var$CARD_WRAPPER_SELECTOR = // Searchspring sometimes renders card wrapper with legacy underscore class.
".card-wrapper, .card_wrapper";
const $b913860f6c9836f6$var$getProductUrlFromCard = (card)=>{
    if (!card) return "";
    return card.getAttribute("data-product-url") || card.querySelector("[data-product-url]")?.getAttribute("data-product-url") || "";
};
const $b913860f6c9836f6$var$findCardImageByProductUrl = (productUrl)=>{
    const productUrlEls = document.querySelectorAll(".card-wrapper[data-product-url], .card_wrapper[data-product-url], .card-wrapper [data-product-url], .card_wrapper [data-product-url]");
    for (const urlEl of productUrlEls){
        const url = urlEl.getAttribute("data-product-url") || "";
        if (url !== productUrl) continue;
        const card = urlEl.closest($b913860f6c9836f6$var$CARD_WRAPPER_SELECTOR);
        const img = (card ?? urlEl).querySelector("img");
        if (img) return img;
    }
    return null;
};
const $b913860f6c9836f6$var$toggleCompareUrl = (productUrl)=>{
    const items = (0, $b40ffbb47bd41a36$export$5e5806013e2fd7ad)();
    const index = items.findIndex((item)=>item.url === productUrl);
    if (index !== -1) {
        items.splice(index, 1);
        $b913860f6c9836f6$var$writeStoredItems(items);
        return false;
    }
    if (items.length >= (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435)) return null;
    const img = $b913860f6c9836f6$var$findCardImageByProductUrl(productUrl) || document.querySelector(".product__media-wrapper img");
    items.push({
        url: productUrl,
        imageSrc: img ? img.currentSrc || img.src : undefined
    });
    $b913860f6c9836f6$var$writeStoredItems(items);
    return true;
};
const $b913860f6c9836f6$var$syncCompareCheckboxes = (root)=>{
    const compareUrls = (0, $b40ffbb47bd41a36$export$5e5806013e2fd7ad)().map((item)=>item.url);
    root.querySelectorAll(".compare-checkbox").forEach((checkbox)=>{
        const card = checkbox.closest($b913860f6c9836f6$var$CARD_WRAPPER_SELECTOR);
        const url = $b913860f6c9836f6$var$getProductUrlFromCard(card);
        checkbox.checked = !!url && compareUrls.includes(url);
    });
    root.querySelectorAll(".compare-pdp-btn").forEach((button)=>{
        const url = button.getAttribute("data-product-url") || "";
        const isActive = !!url && compareUrls.includes(url);
        button.classList.toggle("compare-pdp-btn--active", isActive);
    });
};
const $b913860f6c9836f6$var$updateCompareBar = ()=>{
    const bar = document.getElementById("compare-bar");
    if (!bar) return;
    const comparePageUrl = bar.getAttribute("data-compare-page-url") || "/pages/compare";
    if (location.pathname.startsWith("/pages/compare")) {
        bar.hidden = true;
        return;
    }
    const items = (0, $b40ffbb47bd41a36$export$5e5806013e2fd7ad)().slice(0, (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435));
    const urls = items.map((item)=>item.url);
    if (!urls.length) {
        bar.hidden = true;
        const itemsEl = bar.querySelector(".compare-bar__items");
        if (itemsEl) itemsEl.replaceChildren();
        const linkEl = bar.querySelector(".compare-bar__cta");
        if (linkEl) linkEl.href = comparePageUrl;
        return;
    }
    const handles = urls.map((u)=>/\/products\/([^/?]+)/.exec(u)?.[1]).filter((x)=>Boolean(x)).slice(0, (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435));
    const getBarText = (attr, fallback)=>(0, $b40ffbb47bd41a36$export$5cfeaa4af6841c8f)(bar.getAttribute(attr) || fallback);
    const baseUrl = comparePageUrl;
    bar.hidden = false;
    const itemsEl = bar.querySelector(".compare-bar__items");
    if (itemsEl) {
        itemsEl.replaceChildren();
        for(let i = 0; i < (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435); i++){
            const item = items[i];
            if (!item) {
                const placeholder = document.createElement("div");
                placeholder.className = "compare-bar__thumb compare-bar__thumb--empty";
                itemsEl.appendChild(placeholder);
                continue;
            }
            let src = item.imageSrc;
            if (!src) {
                const productImgFromCard = $b913860f6c9836f6$var$findCardImageByProductUrl(item.url);
                const productImg = productImgFromCard || (location.pathname === item.url ? document.querySelector(".product__media-wrapper img") : null);
                if (productImg) src = productImg.currentSrc || productImg.src;
            }
            if (!src) {
                const placeholder = document.createElement("div");
                placeholder.className = "compare-bar__thumb compare-bar__thumb--empty";
                itemsEl.appendChild(placeholder);
                continue;
            }
            const thumbWrap = document.createElement("div");
            thumbWrap.className = "compare-bar__thumb-wrap";
            const thumbImg = document.createElement("img");
            thumbImg.src = src;
            thumbImg.alt = "";
            thumbImg.loading = "lazy";
            thumbImg.className = "compare-bar__thumb";
            thumbWrap.appendChild(thumbImg);
            const removeBtn = document.createElement("button");
            removeBtn.type = "button";
            removeBtn.className = "compare-bar__thumb-remove";
            removeBtn.setAttribute("aria-label", "Remove from comparison");
            removeBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8 3.4259V12.7592" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33325 8.09253H12.6666" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            removeBtn.addEventListener("click", ()=>{
                const result = $b913860f6c9836f6$var$toggleCompareUrl(item.url);
                if (result !== null) $b913860f6c9836f6$var$syncCompareCheckboxes(document);
            });
            thumbWrap.appendChild(removeBtn);
            itemsEl.appendChild(thumbWrap);
        }
    }
    const linkEl = bar.querySelector(".compare-bar__cta");
    const clearButtonEl = bar.querySelector(".compare-bar__clear");
    if (linkEl) {
        linkEl.textContent = getBarText("data-compare-cta", "Compare");
        const fromUrl = encodeURIComponent(window.location.pathname);
        const fromTitle = encodeURIComponent(document.title);
        linkEl.href = handles.length ? baseUrl + "?" + handles.map((h)=>"handle=" + encodeURIComponent(h)).join("&") + "&from_url=" + fromUrl + "&from_title=" + fromTitle : baseUrl;
        linkEl.hidden = urls.length <= 1;
    }
    if (clearButtonEl) clearButtonEl.hidden = urls.length <= 1;
};
let $b913860f6c9836f6$var$compareAlertTimeout = null;
const $b913860f6c9836f6$var$showCompareLimitAlert = (message)=>{
    const alertEl = document.getElementById("compare-bar-alert");
    if (!(alertEl instanceof HTMLDivElement)) return;
    const msgEl = alertEl.querySelector(".compare-bar-alert__message");
    if (msgEl) msgEl.textContent = message;
    const closeBtn = alertEl.querySelector(".compare-bar-alert__close");
    if (closeBtn instanceof HTMLButtonElement && !closeBtn.dataset.bound) {
        closeBtn.dataset.bound = "true";
        closeBtn.addEventListener("click", ()=>{
            alertEl.style.display = "none";
        });
    }
    alertEl.style.display = "flex";
    if ($b913860f6c9836f6$var$compareAlertTimeout !== null) window.clearTimeout($b913860f6c9836f6$var$compareAlertTimeout);
    $b913860f6c9836f6$var$compareAlertTimeout = window.setTimeout(()=>{
        alertEl.style.display = "none";
    }, 4000);
};
const $b913860f6c9836f6$var$handleCompareClick = (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest(".compare-checkbox, .compare-checkbox-label, .compare-pdp-btn");
    if (!trigger) return;
    const checkboxCandidate = trigger instanceof HTMLInputElement ? trigger : trigger.querySelector(".compare-checkbox");
    const checkbox = checkboxCandidate instanceof HTMLInputElement ? checkboxCandidate : null;
    const button = checkbox ? null : trigger.closest(".compare-pdp-btn");
    const pdpButton = button instanceof HTMLButtonElement ? button : null;
    let url = "";
    if (checkbox) {
        const card = checkbox.closest($b913860f6c9836f6$var$CARD_WRAPPER_SELECTOR);
        url = $b913860f6c9836f6$var$getProductUrlFromCard(card);
    } else url = pdpButton?.getAttribute("data-product-url") || "";
    if (!url) return;
    event.preventDefault();
    const result = $b913860f6c9836f6$var$toggleCompareUrl(url);
    if (result === null) {
        const message = (0, $b40ffbb47bd41a36$export$5cfeaa4af6841c8f)(document.body.getAttribute("data-label-compare-limit") || "") || "Compare limit reached. You can only compare a maximum of 3 products. To compare this product, please remove another first.";
        $b913860f6c9836f6$var$showCompareLimitAlert(message);
        return;
    }
    if (checkbox) checkbox.checked = result;
    $b913860f6c9836f6$var$syncCompareCheckboxes(document);
};
let $b913860f6c9836f6$var$compareInitialized = false;
const $b913860f6c9836f6$var$initCompare = (root)=>{
    if (!$b913860f6c9836f6$var$compareInitialized) {
        document.body.addEventListener("click", $b913860f6c9836f6$var$handleCompareClick);
        window.addEventListener("carbatec:compare-changed", $b913860f6c9836f6$var$updateCompareBar);
        window.addEventListener("storage", (event)=>{
            if (event.key === (0, $b40ffbb47bd41a36$export$7249499643f8b365)) $b913860f6c9836f6$var$updateCompareBar();
        });
        $b913860f6c9836f6$var$compareInitialized = true;
    }
    $b913860f6c9836f6$var$syncCompareCheckboxes(root);
    $b913860f6c9836f6$var$updateCompareBar();
    const clearButtonEl = document.querySelector(".compare-bar__clear");
    if (clearButtonEl && !clearButtonEl.dataset.bound) {
        clearButtonEl.dataset.bound = "true";
        clearButtonEl.addEventListener("click", ()=>{
            $b913860f6c9836f6$var$writeStoredItems([]);
            $b913860f6c9836f6$var$syncCompareCheckboxes(document);
        });
    }
};
$b913860f6c9836f6$var$initCompare(document);
document.addEventListener("shopify:section:load", (event)=>{
    if (event.target instanceof HTMLElement) $b913860f6c9836f6$var$initCompare(event.target);
});




var $ltT5z = parcelRequire("ltT5z");
const $5eceeb465de62a85$var$STOREFRONT_API_URL = "/api/2025-01/graphql.json";
const $5eceeb465de62a85$var$isVariantAvailableForQfc = (node)=>{
    const edges = node.storeAvailability?.edges ?? [];
    if (edges.length === 0) return node.availableForSale;
    return edges.some((edge)=>edge.node.location.name === "QFC" && edge.node.available);
};
const $5eceeb465de62a85$var$compareButtonSpinner = `
  <div class="loading-overlay__spinner hidden">
    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
`;
const $5eceeb465de62a85$var$getMetafieldIdentifiers = (root)=>{
    const groupRows = root.querySelectorAll("#compare-groups tr[data-metafield-namespace][data-metafield-key]");
    const seen = new Set();
    const identifiers = [];
    for (const row of groupRows){
        const namespace = (row.getAttribute("data-metafield-namespace") ?? "").trim();
        const key = (row.getAttribute("data-metafield-key") ?? "").trim();
        if (!namespace || !key) continue;
        const id = `${namespace}:${key}`;
        if (seen.has(id)) continue;
        seen.add(id);
        identifiers.push({
            namespace: namespace,
            key: key
        });
    }
    return identifiers;
};
const $5eceeb465de62a85$var$FIELDS_BASE = `
  id
  title
  handle
  vendor
  tags
  featuredImage { url altText }
  variants(first: 20) {
    edges {
      node {
        id
        sku
        price { amount currencyCode }
        availableForSale
        storeAvailability(first: 10) {
          edges {
            node {
              available
              location { name }
            }
          }
        }
      }
    }
  }
`;
const $5eceeb465de62a85$var$FIELDS_METAFIELDS = `
  metafields(identifiers: $identifiers) {
    namespace
    key
    value
  }
`;
const $5eceeb465de62a85$var$buildQuery = (withMetafields)=>{
    const fields = $5eceeb465de62a85$var$FIELDS_BASE + (withMetafields ? "\n  " + $5eceeb465de62a85$var$FIELDS_METAFIELDS.trim() : "");
    return `
  query($h1: String!, $h2: String!, $h3: String!${withMetafields ? ", $identifiers: [HasMetafieldsIdentifier!]!" : ""}) {
    p1: product(handle: $h1) { ${fields} }
    p2: product(handle: $h2) { ${fields} }
    p3: product(handle: $h3) { ${fields} }
  }`;
};
const $5eceeb465de62a85$var$fetchProducts = (handles, storefrontToken, metafieldIdentifiers)=>{
    if (!handles.length) return Promise.resolve({
        products: []
    });
    const [h1 = "", h2 = "", h3 = ""] = handles;
    const withMetafields = metafieldIdentifiers.length > 0;
    const variables = {
        h1: h1,
        h2: h2,
        h3: h3
    };
    if (withMetafields) variables.identifiers = metafieldIdentifiers;
    return fetch($5eceeb465de62a85$var$STOREFRONT_API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontToken
        },
        body: JSON.stringify({
            query: $5eceeb465de62a85$var$buildQuery(withMetafields),
            variables: variables
        })
    }).then((response)=>response.json()).then((res)=>{
        if (!res.data) return {
            products: [],
            error: res.errors?.[0]?.message || "GraphQL error"
        };
        const productList = [
            res.data.p1,
            res.data.p2,
            res.data.p3
        ].filter((product)=>Boolean(product));
        const products = handles.map((handle)=>productList.find((product)=>product.handle === handle)).filter((product)=>Boolean(product));
        return {
            products: products,
            error: undefined
        };
    }).catch((error)=>({
            products: [],
            error: error instanceof Error ? error.message : "Network error"
        }));
};
const $5eceeb465de62a85$var$getMetafieldValue = (product, namespace, key)=>{
    const metafield = product.metafields?.find((field)=>field != null && field.namespace === namespace && field.key === key);
    return metafield?.value ? String(metafield.value).trim() : "";
};
const $5eceeb465de62a85$var$formatMoney = (amount, currency)=>{
    const root = document.getElementById("compare-root");
    const fmt = root?.getAttribute("data-money-format") || "";
    const value = Number(amount ?? "0") || 0;
    const lang = document.documentElement.lang || "en";
    const formatNumber = (minimumFractionDigits, maximumFractionDigits)=>new Intl.NumberFormat(lang, {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
        }).format(value);
    if (fmt.includes("{{amount_no_decimals}}")) return fmt.replace("{{amount_no_decimals}}", formatNumber(0, 0));
    if (fmt.includes("{{amount}}")) return fmt.replace("{{amount}}", formatNumber(2, 2));
    return new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency || "AUD"
    }).format(value);
};
const $5eceeb465de62a85$var$escapeHtml = (text)=>{
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
};
const $5eceeb465de62a85$var$escapeHtmlAttribute = (value)=>value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const $5eceeb465de62a85$var$areAllValuesEqual = (values)=>values.length <= 1 || values.every((value)=>value === values[0]);
const $5eceeb465de62a85$var$fillSimpleRows = (root, products, rows)=>{
    rows.forEach(({ type: type, getValue: getValue })=>{
        const tr = root.querySelector(`#compare-tbody tr[data-row-type="${type}"]`);
        if (!tr) return;
        const cellValues = [];
        for(let i = 0; i < products.length; i++){
            const td = tr.querySelector(`td[data-product-index="${i}"]`);
            if (!td) continue;
            const value = getValue(products[i]);
            td.textContent = value;
            cellValues.push(value);
        }
        tr.dataset.identical = String($5eceeb465de62a85$var$areAllValuesEqual(cellValues));
    });
};
const $5eceeb465de62a85$var$showEmptyState = (root, message)=>{
    const wrap = root.querySelector("#compare-table-wrap");
    const empty = root.querySelector("#compare-empty");
    if (!wrap || !empty) return;
    wrap.setAttribute("hidden", "");
    empty.removeAttribute("hidden");
    const title = empty.querySelector(".compare__empty-title");
    if (title) title.textContent = (0, $b40ffbb47bd41a36$export$5cfeaa4af6841c8f)(message);
};
const $5eceeb465de62a85$var$fillCompareTable = (root, products, labels)=>{
    const tableWrap = root.querySelector("#compare-table-wrap");
    const emptyState = root.querySelector("#compare-empty");
    const heading = root.querySelector(".compare__heading");
    if (!tableWrap || !emptyState || !heading) return;
    if (!products.length) return;
    emptyState.setAttribute("hidden", "");
    tableWrap.removeAttribute("hidden");
    heading.textContent = labels.heading;
    const hideIdenticalCheckbox = document.getElementById("compare-hide-identical");
    if (hideIdenticalCheckbox instanceof HTMLInputElement) {
        if (!hideIdenticalCheckbox.dataset.compareHideIdenticalBound) {
            hideIdenticalCheckbox.addEventListener("change", ()=>tableWrap.classList.toggle("compare--hide-identical", hideIdenticalCheckbox.checked));
            hideIdenticalCheckbox.dataset.compareHideIdenticalBound = "true";
        }
    }
    const toolbarVendorRow = root.querySelector('#compare-sticky-bar tr[data-row-type="toolbar-vendor"]');
    if (toolbarVendorRow) for(let i = 0; i < (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435); i++){
        const td = toolbarVendorRow.querySelector(`td[data-product-index="${i}"]`);
        if (!td) continue;
        if (i >= products.length) {
            td.textContent = "\u2014";
            continue;
        }
        const product = products[i];
        const vendorText = product.vendor;
        const titleText = product.title;
        const vendorHtml = vendorText ? `<p class="compare-table__vendor-title">${$5eceeb465de62a85$var$escapeHtml(vendorText)}</p>` : "";
        const titleHtml = titleText ? `<p class="compare-table__product-name">${$5eceeb465de62a85$var$escapeHtml(titleText)}</p>` : "";
        const removeHandle = product.handle;
        const safeHandleForData = $5eceeb465de62a85$var$escapeHtmlAttribute(removeHandle);
        const safeRemoveLabel = $5eceeb465de62a85$var$escapeHtmlAttribute(labels.remove);
        const removeButtonHtml = safeHandleForData ? `<button type="button" class="compare-table__remove compare-table__remove--icon" data-handle="${safeHandleForData}" aria-label="${safeRemoveLabel}">\xd7</button>` : "";
        const vendorHeadHtml = vendorHtml || removeButtonHtml ? `<div class="compare-table__vendor-head">${vendorHtml}${removeButtonHtml}</div>` : "";
        const hasContent = vendorHeadHtml || titleHtml;
        td.innerHTML = hasContent ? `<div class="compare-table__vendor-row">${vendorHeadHtml}${titleHtml}</div>` : "\u2014";
    }
    for(let i = 0; i < (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435); i++){
        const th = root.querySelector(`#compare-thead th[data-product-index="${i}"]`);
        if (!th) continue;
        if (i >= products.length) {
            root.querySelectorAll(`[data-product-index="${i}"]`).forEach((el)=>el.classList.add("compare__col-hidden"));
            continue;
        }
        const product = products[i];
        const productHandle = product.handle;
        const productUrlPath = `/products/${encodeURIComponent(productHandle)}`;
        const rawImageUrl = product.featuredImage?.url || "";
        const normalizedImageUrl = rawImageUrl ? rawImageUrl.replace(/^\/\//, "https://") : "";
        const altText = product.featuredImage?.altText || "";
        const imageHtml = normalizedImageUrl ? `<img src="${$5eceeb465de62a85$var$escapeHtmlAttribute(normalizedImageUrl)}" alt="${$5eceeb465de62a85$var$escapeHtmlAttribute(altText)}" width="120" height="120" loading="lazy">` : "";
        const title = $5eceeb465de62a85$var$escapeHtml(product.title);
        th.innerHTML = `<div class="compare-table__product">
      <a href="${productUrlPath}" class="compare-table__img-wrap">${imageHtml}</a>
      <div class="compare-table__product-top">
        <div class="compare-table__product-top-text">
          <a href="${productUrlPath}" class="compare-table__title-link">${title}</a>
        </div>
      </div>
    </div>`;
    }
    const priceValueGetter = (p)=>{
        const price = p.variants?.edges?.[0]?.node?.price;
        return price ? $5eceeb465de62a85$var$formatMoney(price.amount, price.currencyCode) : "\u2014";
    };
    $5eceeb465de62a85$var$fillSimpleRows(root, products, [
        {
            type: "title",
            getValue: (p)=>p.variants?.edges?.[0]?.node?.sku || "\u2014"
        }
    ]);
    const footerPriceRow = root.querySelector('#compare-table-footer tr[data-row-type="priceBottom"]');
    if (footerPriceRow) for(let i = 0; i < products.length; i++){
        const td = footerPriceRow.querySelector(`td[data-product-index="${i}"]`);
        if (!td) continue;
        td.textContent = priceValueGetter(products[i]);
    }
    const footerActionsRow = root.querySelector('#compare-table-footer tr[data-row-type="actions-bottom"]');
    const actionRows = footerActionsRow ? [
        footerActionsRow
    ] : [];
    if (actionRows.length > 0) {
        for(let i = 0; i < products.length; i++){
            const product = products[i];
            const variantEdges = product.variants?.edges ?? [];
            const primaryNode = variantEdges.find((edge)=>$5eceeb465de62a85$var$isVariantAvailableForQfc(edge.node))?.node ?? variantEdges[0]?.node ?? null;
            const isScmQuoteOnly = (0, $ltT5z.isScmQuoteOnlyTitle)(product.title);
            const canAddToCart = primaryNode !== null && $5eceeb465de62a85$var$isVariantAvailableForQfc(primaryNode) && !isScmQuoteOnly;
            const variantId = canAddToCart && primaryNode ? primaryNode.id : null;
            const variantSku = primaryNode?.sku ?? "";
            const isSpecialOrder = Array.isArray(product.tags) ? product.tags.includes("Special Order") : false;
            for (const row of actionRows){
                const actionsCell = row.querySelector(`td[data-product-index="${i}"]`);
                if (!actionsCell) continue;
                if (canAddToCart && variantId) {
                    const skuAttr = variantSku ? ` data-variant-sku="${variantSku}"` : "";
                    const specialOrderAttr = isSpecialOrder ? ' data-special-order="true"' : "";
                    actionsCell.innerHTML = `<button type="button" class="compare-table__atc button button--primary" data-variant-id="${variantId}"${skuAttr}${specialOrderAttr}><span>${labels.addToCart}</span>${$5eceeb465de62a85$var$compareButtonSpinner}</button>`;
                } else actionsCell.innerHTML = `<button type="button" class="compare-table__atc button button--primary" disabled><span>${labels.outOfStock}</span>${$5eceeb465de62a85$var$compareButtonSpinner}</button>`;
            }
        }
        for (const row of actionRows)row.setAttribute("data-identical", "true");
    }
    const metafieldRows = root.querySelectorAll("#compare-groups tr[data-metafield-namespace][data-metafield-key]");
    metafieldRows.forEach((tr)=>{
        const namespace = (tr.getAttribute("data-metafield-namespace") ?? "").trim();
        const key = (tr.getAttribute("data-metafield-key") ?? "").trim();
        if (!namespace || !key) return;
        const cellValues = [];
        for(let i = 0; i < products.length; i++){
            const td = tr.querySelector(`td[data-product-index="${i}"]`);
            if (!td) continue;
            const value = $5eceeb465de62a85$var$getMetafieldValue(products[i], namespace, key) || "\u2014";
            td.textContent = value;
            cellValues.push(value);
        }
        if (cellValues.every((v)=>v === "\u2014")) {
            tr.setAttribute("hidden", "");
            return;
        }
        tr.removeAttribute("hidden");
        tr.setAttribute("data-identical", $5eceeb465de62a85$var$areAllValuesEqual(cellValues) ? "true" : "false");
    });
    const groups = root.querySelectorAll("#compare-groups .compare__group");
    for (const group of groups){
        const rows = group.querySelectorAll("tr.compare-group-row");
        let hasValueRow = false;
        for (const row of rows)if (!row.hasAttribute("hidden")) {
            hasValueRow = true;
            break;
        }
        if (!hasValueRow) group.setAttribute("hidden", "");
        else group.removeAttribute("hidden");
    }
    for(let i = products.length; i < (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435); i++)root.querySelectorAll(`[data-product-index="${i}"]`).forEach((el)=>el.remove());
};
function $5eceeb465de62a85$var$renderCompareBreadcrumbs(container) {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("from_url") ?? "";
    const fromTitle = params.get("from_title") ?? "";
    if (!fromUrl.startsWith("/") || !fromTitle) return;
    const nav = container.querySelector("nav");
    const fromLink = container.querySelector(".compare-breadcrumbs__from");
    const fromSpan = fromLink?.querySelector("span");
    if (!nav || !fromLink || !fromSpan) return;
    fromLink.href = fromUrl;
    fromSpan.textContent = fromTitle;
    nav.removeAttribute("hidden");
}
function $5eceeb465de62a85$var$updateComparePageUrl(handles, baseUrl) {
    if (!("history" in window)) return;
    try {
        const url = new URL(baseUrl, window.location.origin);
        const existingParams = new URLSearchParams(window.location.search);
        const fromUrl = existingParams.get("from_url");
        const fromTitle = existingParams.get("from_title");
        url.search = "";
        for (const handle of handles.slice(0, (0, $b40ffbb47bd41a36$export$c4cbb7f74da17435)))url.searchParams.append("handle", handle);
        if (fromUrl) url.searchParams.set("from_url", fromUrl);
        if (fromTitle) url.searchParams.set("from_title", fromTitle);
        window.history.replaceState(null, "", url.toString());
    } catch (_error) {
        console.error("[compare-page] Failed to update compare URL", _error);
    }
}
function $5eceeb465de62a85$var$renderCompare(root) {
    const breadcrumbsContainer = document.getElementById("compare-breadcrumbs");
    if (breadcrumbsContainer) $5eceeb465de62a85$var$renderCompareBreadcrumbs(breadcrumbsContainer);
    const productHandles = (0, $b40ffbb47bd41a36$export$de3ad5aa5028f2d0)();
    const baseUrl = root.getAttribute("data-compare-base-url") || location.pathname || "/pages/compare";
    $5eceeb465de62a85$var$updateComparePageUrl(productHandles, baseUrl);
    const storefrontToken = (root.getAttribute("data-storefront-token") || "").trim();
    if (productHandles.length && !storefrontToken) return $5eceeb465de62a85$var$showEmptyState(root, root.getAttribute("data-compare-token-required") || "Add Storefront API token.");
    if (!productHandles.length) return $5eceeb465de62a85$var$showEmptyState(root, root.getAttribute("data-compare-empty") || "Add products to compare.");
    const getTextAttr = (attr, fallback)=>(0, $b40ffbb47bd41a36$export$5cfeaa4af6841c8f)(root.getAttribute(attr) || fallback);
    const labels = {
        remove: getTextAttr("data-compare-remove", "Remove"),
        addToCart: getTextAttr("data-compare-add-to-cart", "Add to cart"),
        outOfStock: getTextAttr("data-compare-out-of-stock", "Sold out"),
        heading: getTextAttr("data-compare-heading", "Compare products")
    };
    $5eceeb465de62a85$var$fetchProducts(productHandles, storefrontToken, $5eceeb465de62a85$var$getMetafieldIdentifiers(root)).then((res)=>{
        if (res.error) return $5eceeb465de62a85$var$showEmptyState(root, res.error);
        if (!res.products.length) return $5eceeb465de62a85$var$showEmptyState(root, root.getAttribute("data-compare-load-failed") || "Could not load products.");
        $5eceeb465de62a85$var$fillCompareTable(root, res.products, labels);
    });
}
let $5eceeb465de62a85$var$comparePageInitialized = false;
const $5eceeb465de62a85$var$handleCompareAtcClick = async (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest(".compare-table__atc");
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const variantIdAttr = button.getAttribute("data-variant-id");
    if (!variantIdAttr) return;
    const variantIdNumeric = variantIdAttr.startsWith("gid://") ? variantIdAttr.split("/").pop() ?? variantIdAttr : variantIdAttr;
    button.disabled = true;
    button.classList.add("loading");
    button.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");
    const cartElement = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    const addUrl = typeof routes !== "undefined" && routes?.cart_add_url ? routes.cart_add_url : "/cart/add.js";
    const config = {
        method: "POST",
        headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest"
        }
    };
    const formData = new FormData();
    formData.append("id", variantIdNumeric);
    formData.append("quantity", "1");
    const root = document.getElementById("compare-root");
    const skuLabel = root?.getAttribute("data-compare-sku-label") || "SKU";
    const variantSkuAttr = button.getAttribute("data-variant-sku") || "";
    const variantSku = variantSkuAttr.trim();
    if (variantSku && skuLabel) formData.append(`properties[${skuLabel}]`, variantSku);
    const isSpecialOrder = button.getAttribute("data-special-order") === "true";
    if (isSpecialOrder) formData.append("properties[_special_order]", "true");
    const cartApi = cartElement && typeof cartElement === "object" ? cartElement : null;
    const getSectionsToRender = cartApi ? Reflect.get(cartApi, "getSectionsToRender") : undefined;
    const setActiveElement = cartApi ? Reflect.get(cartApi, "setActiveElement") : undefined;
    const renderContents = cartApi ? Reflect.get(cartApi, "renderContents") : undefined;
    if (typeof getSectionsToRender === "function") {
        const sections = getSectionsToRender.call(cartApi);
        if (Array.isArray(sections) && sections.length) {
            const sectionIds = sections.map((section)=>{
                if (typeof section !== "object" || section === null) return "";
                const id = Reflect.get(section, "id");
                return typeof id === "string" ? id : "";
            }).filter(Boolean).join(",");
            if (sectionIds) formData.append("sections", sectionIds);
        }
        formData.append("sections_url", window.location.pathname);
        if (typeof setActiveElement === "function") setActiveElement.call(cartApi, document.activeElement);
    }
    config.body = formData;
    let shouldReenable = true;
    try {
        const response = await fetch(addUrl, config);
        const parsed = await response.json().catch(()=>({}));
        const payloadStatusValue = typeof parsed === "object" && parsed !== null ? Reflect.get(parsed, "status") : undefined;
        const payloadStatus = typeof payloadStatusValue === "number" ? payloadStatusValue : undefined;
        if (!response.ok || payloadStatus && payloadStatus >= 400) return;
        shouldReenable = false;
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "compare-page",
            productVariantId: variantIdNumeric,
            cartData: parsed
        });
        if (typeof renderContents === "function") renderContents.call(cartApi, parsed);
    } catch (error) {
        console.error("[compare-page] Failed to add to cart", error);
    } finally{
        button.classList.remove("loading");
        button.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
        if (shouldReenable) button.disabled = false;
    }
};
const $5eceeb465de62a85$var$handleCompareRemoveClick = (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest(".compare-table__remove");
    if (!button) return;
    const handle = button.getAttribute("data-handle") ?? "";
    if (!handle) return;
    event.preventDefault();
    try {
        const updated = (0, $b40ffbb47bd41a36$export$5e5806013e2fd7ad)().filter((item)=>/\/products\/([^/?]+)/.exec(item.url)?.[1] !== handle);
        localStorage.setItem((0, $b40ffbb47bd41a36$export$7249499643f8b365), JSON.stringify(updated));
        window.dispatchEvent(new CustomEvent("carbatec:compare-changed"));
    } catch (error) {
        console.error("[compare-page] Failed to update compare list on remove", error);
    }
};
const $5eceeb465de62a85$var$handleGroupSummaryClick = (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summaryRow = target.closest(".compare__group-summary");
    if (!summaryRow) return;
    const group = summaryRow.closest(".compare__group");
    if (!(group instanceof HTMLElement)) return;
    const isCollapsed = group.dataset.collapsed === "true";
    group.dataset.collapsed = isCollapsed ? "false" : "true";
};
const $5eceeb465de62a85$var$bindCompareAtc = (root)=>{
    if (root.dataset.compareAtcBound === "true") return;
    root.dataset.compareAtcBound = "true";
    root.addEventListener("click", $5eceeb465de62a85$var$handleCompareAtcClick);
    root.addEventListener("click", $5eceeb465de62a85$var$handleCompareRemoveClick);
    root.addEventListener("click", $5eceeb465de62a85$var$handleGroupSummaryClick);
};
const $5eceeb465de62a85$var$initCompareStickyBar = (root)=>{
    if (root.dataset.compareStickyBarBound === "true") return;
    root.dataset.compareStickyBarBound = "true";
    const scrollInner = root.querySelector(".compare__table-scroll-inner");
    const stickyBar = root.querySelector("#compare-sticky-bar");
    const stickyFooter = root.querySelector("#compare-sticky-footer");
    if (!scrollInner || !stickyBar) return;
    const stickyTargets = stickyFooter ? [
        stickyBar,
        stickyFooter
    ] : [
        stickyBar
    ];
    let isSyncing = false;
    const syncScrollLeft = (source, targets)=>{
        if (isSyncing) return;
        const left = source.scrollLeft;
        isSyncing = true;
        for (const target of targets){
            if (target.scrollLeft === left) continue;
            target.scrollLeft = left;
        }
        requestAnimationFrame(()=>{
            isSyncing = false;
        });
    };
    scrollInner.addEventListener("scroll", ()=>syncScrollLeft(scrollInner, stickyTargets), {
        passive: true
    });
    syncScrollLeft(scrollInner, stickyTargets);
};
const $5eceeb465de62a85$var$initComparePage = ()=>{
    const root = document.getElementById("compare-root");
    if (!root) return;
    $5eceeb465de62a85$var$bindCompareAtc(root);
    $5eceeb465de62a85$var$renderCompare(root);
    $5eceeb465de62a85$var$initCompareStickyBar(root);
    if (!$5eceeb465de62a85$var$comparePageInitialized) {
        const rerender = ()=>{
            const currentRoot = document.getElementById("compare-root");
            if (currentRoot) $5eceeb465de62a85$var$renderCompare(currentRoot);
        };
        window.addEventListener("carbatec:compare-changed", rerender);
        window.addEventListener("storage", (event)=>{
            if (event.key === (0, $b40ffbb47bd41a36$export$7249499643f8b365)) rerender();
        });
        $5eceeb465de62a85$var$comparePageInitialized = true;
    }
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $5eceeb465de62a85$var$initComparePage);
else $5eceeb465de62a85$var$initComparePage();
document.addEventListener("shopify:section:load", $5eceeb465de62a85$var$initComparePage);



const $5fe3604b02912324$var$BADGES_SELECTOR = '[data-entity="ss-badges"]';
const $5fe3604b02912324$var$FETCH_TIMEOUT_MS = 8000;
const $5fe3604b02912324$var$fetchJson = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $5fe3604b02912324$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        credentials: "omit",
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};
async function $5fe3604b02912324$var$fetchBadges(siteId, sku) {
    const encodedSiteId = encodeURIComponent(siteId);
    const encodedSku = encodeURIComponent(sku);
    const url = `https://api.searchspring.net/api/search/search.json?siteId=${encodedSiteId}&resultsFormat=native&resultsPerPage=10&q=${encodedSku}`;
    const data = await $5fe3604b02912324$var$fetchJson(url);
    const results = data?.results;
    if (!results || !results.length) return [];
    const exactMatch = results.find((result)=>result.sku === sku);
    const source = exactMatch ?? results[0];
    return source.badges && Array.isArray(source.badges) ? source.badges : [];
}
async function $5fe3604b02912324$var$mountBadges(containerElement) {
    if (containerElement.dataset.ssBadgesBound === "true" || containerElement.childElementCount) return;
    const { id: sku, siteId: siteId } = containerElement.dataset;
    if (!sku || !siteId) return;
    containerElement.dataset.ssBadgesBound = "true";
    const [fetchedBadges, tagsConfig] = await Promise.all([
        $5fe3604b02912324$var$fetchBadges(siteId, sku),
        (0, $7d1b13016aa3d0bd$export$8545333153626f43)(siteId, $5fe3604b02912324$var$fetchJson)
    ]);
    const hideSoldOut = containerElement.dataset.hideSoldOut === "true";
    const badges = hideSoldOut ? fetchedBadges.filter((badge)=>{
        const normalizedTag = (badge.tag ?? "").trim().toLowerCase();
        const normalizedValue = (badge.value ?? "").trim().toLowerCase();
        return normalizedTag !== "sold-out" && normalizedTag !== "soldout" && !normalizedTag.includes("sold out") && !normalizedValue.includes("sold out");
    }) : fetchedBadges;
    if (badges.length) (0, $7d1b13016aa3d0bd$export$1a6553668c5e7a2c)(containerElement, badges, tagsConfig);
}
function $5fe3604b02912324$var$mountBadgesIn(rootNode) {
    rootNode.querySelectorAll($5fe3604b02912324$var$BADGES_SELECTOR).forEach((element)=>{
        if (element instanceof HTMLElement) $5fe3604b02912324$var$mountBadges(element);
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5fe3604b02912324$var$mountBadgesIn(document));
else $5fe3604b02912324$var$mountBadgesIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetElement = event.target;
    if (targetElement instanceof HTMLElement) $5fe3604b02912324$var$mountBadgesIn(targetElement);
});


parcelRequire("695Bn");
const $a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR = ".swym-wishlist-item";
const $a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR = ".swym-wishlist-image-wrapper";
const $a970e57ee1a335bc$var$WISHLIST_VARIANT_TITLE_SELECTOR = ".swym-variant-title";
const $a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY = "wishlistSkuBound";
const $a970e57ee1a335bc$var$SWYM_WISHLIST_PRODUCTS_KEY = "swym-products";
let $a970e57ee1a335bc$var$cachedWishlistProducts;
const $a970e57ee1a335bc$var$isObject = (value)=>typeof value === "object" && value !== null;
const $a970e57ee1a335bc$var$isSwymWishlistStorage = (value)=>$a970e57ee1a335bc$var$isObject(value) && "all" in value;
const $a970e57ee1a335bc$var$isSwymWishlistRawItem = (value)=>$a970e57ee1a335bc$var$isObject(value);
const $a970e57ee1a335bc$var$readVariantId = (value)=>{
    if (value == null) return null;
    if (typeof value === "number") return String(value);
    if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed || null;
    }
    return null;
};
const $a970e57ee1a335bc$var$loadWishlistProducts = ()=>{
    if ($a970e57ee1a335bc$var$cachedWishlistProducts !== undefined) return $a970e57ee1a335bc$var$cachedWishlistProducts;
    if (typeof window === "undefined" || !window.localStorage) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    const raw = window.localStorage.getItem($a970e57ee1a335bc$var$SWYM_WISHLIST_PRODUCTS_KEY);
    if (!raw) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    try {
        const parsed = JSON.parse(raw);
        if (!$a970e57ee1a335bc$var$isSwymWishlistStorage(parsed) || !Array.isArray(parsed.all)) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
        const products = parsed.all.reduce((acc, item)=>{
            if (!$a970e57ee1a335bc$var$isSwymWishlistRawItem(item) || typeof item.sku !== "string") return acc;
            const sku = item.sku.trim();
            if (!sku) return acc;
            acc.push({
                sku: sku,
                variantId: $a970e57ee1a335bc$var$readVariantId(item.epi)
            });
            return acc;
        }, []);
        return $a970e57ee1a335bc$var$cachedWishlistProducts = products.length ? products : null;
    } catch  {
        return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    }
};
const $a970e57ee1a335bc$var$getVariantIdFromUrl = (url)=>{
    const value = url.searchParams.get("variant")?.trim() ?? "";
    return value || null;
};
const $a970e57ee1a335bc$var$findSkuForVariant = (variantId)=>{
    if (!variantId) return null;
    const products = $a970e57ee1a335bc$var$loadWishlistProducts();
    if (!products) return null;
    return products.find((product)=>product.variantId === variantId) ?? null;
};
const $a970e57ee1a335bc$var$enhanceWishlistItem = (itemElement)=>{
    if (itemElement.dataset[$a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY] === "true") return;
    const linkElement = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR);
    const skuElement = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_VARIANT_TITLE_SELECTOR);
    if (!(linkElement instanceof HTMLAnchorElement)) return;
    if (!(skuElement instanceof HTMLElement)) return;
    const existingText = skuElement.textContent?.trim() || "";
    let url;
    try {
        url = new URL(linkElement.href, window.location.origin);
    } catch  {
        return;
    }
    const fromSwym = $a970e57ee1a335bc$var$findSkuForVariant($a970e57ee1a335bc$var$getVariantIdFromUrl(url));
    if (!fromSwym) return;
    const { sku: sku, variantId: variantId } = fromSwym;
    if (variantId) itemElement.dataset.variantId = variantId;
    itemElement.dataset.sku = sku;
    itemElement.dataset[$a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY] = "true";
    const container = document.getElementById("swym-wishlist-render-container");
    const label = container instanceof HTMLElement ? container.dataset.labelSku?.trim() || null : null;
    const skuText = label ? `${label}: ${sku}` : sku;
    skuElement.textContent = existingText ? `${existingText} \xb7 ${skuText}` : skuText;
};
const $a970e57ee1a335bc$var$enhanceWishlistIn = (rootNode)=>{
    rootNode.querySelectorAll($a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR).forEach((element)=>{
        if (element instanceof HTMLElement) $a970e57ee1a335bc$var$enhanceWishlistItem(element);
    });
};
const $a970e57ee1a335bc$var$observeWishlist = ()=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return;
    const observer = new MutationObserver(()=>{
        $a970e57ee1a335bc$var$enhanceWishlistIn(container);
    });
    observer.observe(container, {
        childList: true,
        subtree: true
    });
};
const $a970e57ee1a335bc$var$handleWishlistItemClick = (event)=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!container.contains(target)) return;
    const button = target.closest("button");
    if (button && button.matches(".swym-delete-btn, .swym-add-to-cart-btn, .swym-wishlist-add-to-cart-btn")) return;
    const itemElement = target.closest($a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR);
    if (!(itemElement instanceof HTMLElement)) return;
    const imageLink = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR);
    if (!(imageLink instanceof HTMLAnchorElement)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.href = imageLink.href;
};
const $a970e57ee1a335bc$var$initWishlistNavigation = ()=>{
    document.addEventListener("click", $a970e57ee1a335bc$var$handleWishlistItemClick, true);
};
$a970e57ee1a335bc$var$enhanceWishlistIn(document);
$a970e57ee1a335bc$var$observeWishlist();
$a970e57ee1a335bc$var$initWishlistNavigation();


parcelRequire("9ei6z");
const $ac617f9c4278b30e$var$TOGGLE_SELECTOR = ".seo-content__text-toggle";
const $ac617f9c4278b30e$var$COLLAPSIBLE_CLASS = "is-collapsible";
const $ac617f9c4278b30e$var$OPEN_CLASS = "is-open";
const $ac617f9c4278b30e$var$initSeoContent = ()=>{
    const btn = document.querySelector($ac617f9c4278b30e$var$TOGGLE_SELECTOR);
    if (!(btn instanceof HTMLButtonElement)) return;
    btn.classList.add("is-ready");
    const id = btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (!wrap) return;
    wrap.classList.add($ac617f9c4278b30e$var$COLLAPSIBLE_CLASS);
    const expanded = btn.getAttribute("aria-expanded") === "true";
    wrap.setAttribute("aria-hidden", String(!expanded));
    if (expanded) {
        wrap.classList.add($ac617f9c4278b30e$var$OPEN_CLASS);
        wrap.style.maxHeight = `${wrap.scrollHeight}px`;
    }
    btn.addEventListener("click", ()=>{
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        if (!isExpanded) {
            btn.setAttribute("aria-expanded", "true");
            wrap.classList.add($ac617f9c4278b30e$var$OPEN_CLASS);
            wrap.setAttribute("aria-hidden", "false");
            requestAnimationFrame(()=>{
                wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            });
        } else {
            btn.setAttribute("aria-expanded", "false");
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            requestAnimationFrame(()=>{
                wrap.classList.remove($ac617f9c4278b30e$var$OPEN_CLASS);
                wrap.setAttribute("aria-hidden", "true");
                wrap.style.maxHeight = "";
            });
        }
        const labelMore = btn.dataset.labelMore;
        const labelLess = btn.dataset.labelLess;
        const span = btn.querySelector("span");
        if (span && labelMore && labelLess) span.textContent = isExpanded ? labelMore : labelLess;
    });
};
$ac617f9c4278b30e$var$initSeoContent();


parcelRequire("aKoSb");

const $26c9201c27b73b7a$var$ROOT_SELECTOR = "[data-ss-recommendations-root]";
const $26c9201c27b73b7a$var$CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const $26c9201c27b73b7a$var$LINK_SELECTOR = 'a[href*="/products/"]';
const $26c9201c27b73b7a$var$OVERLAY_SELECTOR = ".ss__overlay-badge";
function $26c9201c27b73b7a$var$getHandleFromCard(card) {
    const href = card.querySelector($26c9201c27b73b7a$var$LINK_SELECTOR)?.getAttribute("href") ?? "";
    if (!href) return "";
    const match = href.match(/\/products\/([^/?#]+)/);
    return match?.[1]?.trim() ?? "";
}
async function $26c9201c27b73b7a$var$mountBadgesInRoot(root) {
    const siteId = root.dataset.ssSiteId?.trim() ?? "";
    if (!siteId) return;
    const cards = root.querySelectorAll($26c9201c27b73b7a$var$CARD_SELECTOR);
    if (!cards.length) return;
    await (0, $5d96ad27182ef356$export$18625d2560c7ad35)({
        siteId: siteId,
        cards: cards,
        getHandleFromCard: $26c9201c27b73b7a$var$getHandleFromCard,
        shouldSkipCard: (card)=>Boolean(card.querySelector($26c9201c27b73b7a$var$OVERLAY_SELECTOR))
    });
}
document.querySelectorAll($26c9201c27b73b7a$var$ROOT_SELECTOR).forEach((root)=>{
    const mount = ()=>void $26c9201c27b73b7a$var$mountBadgesInRoot(root);
    if (root.querySelector($26c9201c27b73b7a$var$CARD_SELECTOR)) return mount();
    const observer = new MutationObserver(()=>{
        if (!root.querySelector($26c9201c27b73b7a$var$CARD_SELECTOR)) return;
        observer.disconnect();
        mount();
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
});


parcelRequire("dcGpq");

})();
//# sourceMappingURL=global.js.map
